'use strict';

var _ = require('lodash');
var FaresSurchargeUploadTransformerFactory = function FaresSurchargeUploadTransformerFactory(DataTransformer, momentService) {
  function FaresSurchargeUploadTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'fares-surcharge-upload-mode';
    this.priority = 1;
  }
  FaresSurchargeUploadTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  FaresSurchargeUploadTransformerFactory.constructor = FaresSurchargeUploadTransformerFactory;
  FaresSurchargeUploadTransformerFactory.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  FaresSurchargeUploadTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  FaresSurchargeUploadTransformerFactory.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  FaresSurchargeUploadTransformerFactory.prototype.transform = function (data) {
    var memoizedMomentOfApplicableDateRange = _.memoize(getMomentOfDate);
    if (data.domain.yqyrsurchargeRecords) {
      var results = _.transform(data.domain.yqyrsurchargeRecords, function (result, item) {
        var newEntity = {
          className: item.fareClass,
          origin: item.marketOrigin,
          destination: item.marketDestination,
          surcharge: item.surcharge,
          spos: item.spos,
          effectiveDate: memoizedMomentOfApplicableDateRange(item.begin, momentService.FIELD.APPLICABLE_DATE_RANGE),
          discontinueDate: memoizedMomentOfApplicableDateRange(item.end, momentService.FIELD.APPLICABLE_DATE_RANGE)
        };
        result.push(newEntity);
      });
      return results;
    } else {
      return [];
      //TODO: You can add unit test for empty array returned
    }
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return FaresSurchargeUploadTransformerFactory;
};
FaresSurchargeUploadTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = FaresSurchargeUploadTransformerFactory;